const SHIFT_AMOUNTS = [
  7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22,
  5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20,
  4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23,
  6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21,
] as const;

const TABLE = new Uint32Array(64);
for (let i = 0; i < TABLE.length; i += 1) {
  TABLE[i] = Math.floor(Math.abs(Math.sin(i + 1)) * 0x100000000) >>> 0;
}

function rotateLeft(value: number, amount: number): number {
  return (value << amount) | (value >>> (32 - amount));
}

function wordToHex(value: number): string {
  let out = '';
  for (let i = 0; i < 4; i += 1) {
    out += ((value >>> (i * 8)) & 0xff).toString(16).padStart(2, '0');
  }
  return out;
}

export async function md5HexFromBlob(blob: Blob): Promise<string> {
  const input = new Uint8Array(await blob.arrayBuffer());
  let paddedLength = input.length + 1;
  while (paddedLength % 64 !== 56) paddedLength += 1;

  const message = new Uint8Array(paddedLength + 8);
  message.set(input);
  message[input.length] = 0x80;

  const view = new DataView(message.buffer);
  const bitLength = input.length * 8;
  view.setUint32(paddedLength, bitLength >>> 0, true);
  view.setUint32(paddedLength + 4, Math.floor(bitLength / 0x100000000), true);

  let a0 = 0x67452301;
  let b0 = 0xefcdab89;
  let c0 = 0x98badcfe;
  let d0 = 0x10325476;

  for (let offset = 0; offset < message.length; offset += 64) {
    let a = a0;
    let b = b0;
    let c = c0;
    let d = d0;

    for (let i = 0; i < 64; i += 1) {
      let f: number;
      let g: number;
      if (i < 16) {
        f = (b & c) | (~b & d);
        g = i;
      } else if (i < 32) {
        f = (d & b) | (~d & c);
        g = (5 * i + 1) % 16;
      } else if (i < 48) {
        f = b ^ c ^ d;
        g = (3 * i + 5) % 16;
      } else {
        f = c ^ (b | ~d);
        g = (7 * i) % 16;
      }

      const next = d;
      d = c;
      c = b;
      const sum = (a + f + (TABLE[i] ?? 0) + view.getUint32(offset + g * 4, true)) >>> 0;
      b = (b + rotateLeft(sum, SHIFT_AMOUNTS[i] ?? 0)) >>> 0;
      a = next;
    }

    a0 = (a0 + a) >>> 0;
    b0 = (b0 + b) >>> 0;
    c0 = (c0 + c) >>> 0;
    d0 = (d0 + d) >>> 0;
  }

  return wordToHex(a0) + wordToHex(b0) + wordToHex(c0) + wordToHex(d0);
}
